export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }

    getParams (question, filter, list) {
        const filterCopy = angular.copy(filter);
        filterCopy.metaSearch = JSON.stringify(filterCopy.metaSearch);

        const sort = list.sort ? { sort: list.sort } : {};

        return this.lodash.assign({}, filterCopy, { id: question.id, page: list.pagination.currentPage }, sort);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question/route/index.js